import { render, staticRenderFns } from "./CustomFieldPanel.vue?vue&type=template&id=198ddbbf&scoped=true"
import script from "./CustomFieldPanel.vue?vue&type=script&lang=js"
export * from "./CustomFieldPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ddbbf",
  null
  
)

export default component.exports